import angular from 'angular';
import uiRouter from 'angular-ui-router';
import {ROUTES} from 'common/domain/routes';
import {STATES} from 'common/domain/states';
import loansRepaymentComponent from './loansRepayment.component';
import loansRepaymentLoanInfo from './loansRepaymentLoanInfo/loansRepaymentLoanInfo';
import loansRepaymentForm from './loansRepaymentForm/loansRepaymentForm';
import loansRepaymentModal from './loansRepaymentModal/loansRepaymentModal';
import loansRepaymentService from './loansRepayment.service';
import loansRepaymentSimulate from './loansRepaymentSimulate/loansRepaymentSimulate';

let loansRepaymentModule = angular.module('loansRepayment', [
  uiRouter,
  loansRepaymentLoanInfo,
  loansRepaymentForm,
  loansRepaymentModal,
  loansRepaymentSimulate
])

  .component('loansRepayment', loansRepaymentComponent)

  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state(STATES.LOANS.REPAYMENT, {
        url: ROUTES.LOANS.REPAYMENT,
        component: 'loansRepayment',
        params: {
          loan: null
        },
        data: {
          requiresAuth: true
        }
      });
  })

  .service('loansRepaymentService', loansRepaymentService)

  .name;

export default loansRepaymentModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepayment.js